import React from "react";

import { Loader } from "../loader";

import styles from "./styles.modules.scss";

export const Loading = ({
    primary,
    light,
}: {
    primary?: boolean;
    light?: boolean;
}) => {
    // Primary loading is used for main loading screens to not break smoke tests
    return (
        <div
            className={`loading ${primary ? "primary" : ""} ${styles.loading}`}
        >
            <Loader light={light} />
        </div>
    );
};
